export const AvailablePlatformName = {
  p001: '1', //20bet
  p002: '2', //bet20Win
  p003: '3', //tonyNL
  p004: '4', //tonyKE
  p005: '5', //tonyEE
  p006: '6', //tonyLV
  p007: '7', //tonyNG
  p008: '8', //tonyES
  p009: '9', //tonyCA
  p010: '10', //tonyPT
  p011: '11', //tonyAU
  p012: '12', //bet22
  p013: '13', //bet22Senegal
  p014: '14', //bet22Cameroon
  p015: '15', //bet22Congo
  p016: '16', //bet22Mozambique
  p017: '17', //bet22Zambia
  p018: '18', //bet22Burundi
  p019: '19', //bet22Ghana
  p020: '20', //ivibet
  p021: '21', //nationalBase
  p022: '22', //nationalBizzo
  p023: '23', //hellspinBase
  p024: '24', //sofobetBase
  p025: '25', //vave
  p026: '26', //tonywinae
  p027: '27', //granawin
  p032: '32', //dragonslots
  p033: '33', //slotsgem
  p121: '121', //bet22casino
  p211: '211', //spinid
  p1000: '1000', //safecasino
  p1001: '1001', //slotrave
  p1002: '1002', //royalXO
  p1003: '1003', //betlabel
  p1004: '1004', //tritonslots
  p1005: '1005', //new-tonyEE

  none: '',
};

const Platforms: Record<string, string> = {
  [AvailablePlatformName.p001]: 'theme_001',
  [AvailablePlatformName.p002]: 'theme_001',
  [AvailablePlatformName.p003]: 'theme_002',
  [AvailablePlatformName.p004]: 'theme_002',
  [AvailablePlatformName.p005]: 'theme_002',
  [AvailablePlatformName.p006]: 'theme_002',
  [AvailablePlatformName.p007]: 'theme_002',
  [AvailablePlatformName.p008]: 'theme_002',
  [AvailablePlatformName.p009]: 'theme_002',
  [AvailablePlatformName.p010]: 'theme_002',
  [AvailablePlatformName.p011]: 'theme_002',
  [AvailablePlatformName.p012]: 'theme_003',
  [AvailablePlatformName.p013]: 'theme_003',
  [AvailablePlatformName.p014]: 'theme_003',
  [AvailablePlatformName.p015]: 'theme_003',
  [AvailablePlatformName.p016]: 'theme_003',
  [AvailablePlatformName.p017]: 'theme_003',
  [AvailablePlatformName.p018]: 'theme_003',
  [AvailablePlatformName.p019]: 'theme_003',
  [AvailablePlatformName.p020]: 'theme_004',
  [AvailablePlatformName.p021]: 'theme_005',
  [AvailablePlatformName.p022]: 'theme_006',
  [AvailablePlatformName.p023]: 'theme_007',
  [AvailablePlatformName.p024]: 'theme_008',
  [AvailablePlatformName.p025]: 'theme_009',
  [AvailablePlatformName.p026]: 'theme_010',
  [AvailablePlatformName.p027]: 'theme_011',
  [AvailablePlatformName.p032]: 'theme_012',
  [AvailablePlatformName.p033]: 'theme_013',
  [AvailablePlatformName.p121]: 'theme_014',
  [AvailablePlatformName.p211]: 'theme_015',
  [AvailablePlatformName.p1000]: 'theme_016',
  [AvailablePlatformName.p1001]: 'theme_017',
  [AvailablePlatformName.p1002]: 'theme_018',
  [AvailablePlatformName.p1003]: 'theme_019',
  [AvailablePlatformName.p1004]: 'theme_020',
  [AvailablePlatformName.p1005]: 'theme_021',
};

export const getThemeId = (platform: string): string | null =>
  Platforms[platform] ?? null;
